import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UnstyledButton } from '@mantine/core';
import { TextField } from '@ui-lib';

import * as styles from './NameFields.css';

interface NameFieldsProps {
  firstName: string;
  lastName: string;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  /** Opens the full name editor for middle name, prefix, suffix, pronouns and the like. */
  onMoreFields: () => void;
}

/**
 * The name inputs exposed directly on the customize-card step, so a new user can
 * see what unlocks "Next" without opening the card's name popover first.
 */
export const NameFields: React.FC<NameFieldsProps> = ({
  firstName,
  lastName,
  onFirstNameChange,
  onLastNameChange,
  onMoreFields,
}) => (
  <div className={styles.root}>
    <div className={styles.fields}>
      <TextField
        size="large25"
        tone="neutral25"
        label="First name"
        value={firstName}
        onChange={(event) => onFirstNameChange(event.currentTarget.value)}
        autoComplete="given-name"
        autoCapitalize="words"
        required
        aria-required
        message="Required to create your card"
      />
      <TextField
        size="large25"
        tone="neutral25"
        label="Last name"
        value={lastName}
        onChange={(event) => onLastNameChange(event.currentTarget.value)}
        autoComplete="family-name"
        autoCapitalize="words"
      />
    </div>
    <div className={styles.moreFields}>
      <UnstyledButton className={styles.moreFieldsButton} onClick={onMoreFields}>
        <span className={styles.moreFieldsIcon} aria-hidden>
          <FontAwesomeIcon icon={faPlus} />
        </span>
        More name fields
      </UnstyledButton>
    </div>
  </div>
);

export default NameFields;
